export enum LanguageCodes {
    de = 'de',
    en = 'en',
    fr = 'fr',
    nl = 'nl',
    cs = 'cs',
    es = 'es',
    pl = 'pl',
    sk = 'sk'
}
